import React from 'react';
import { format } from 'date-fns';
import Grid from '@mui/material/Grid';
import ListPage from '../../../sharedModules/listPage/ListPage';
import { SelectOption } from '../../../sharedModules/form/model';
import { useGet } from '../../../sharedModules/hooks/useQuery';

const formatCompletedAt = (value: string | null | undefined): string => {
  if (value == null) return '';
  try {
    return format(new Date(value), 'MM/dd/yyyy');
  } catch {
    return value;
  }
};

const reportColumns = [
  {
    name: 'Name',
    selector: 'name',
    sortable: true,
    grow: 1,
  },
  {
    name: 'Technician',
    selector: 'technician',
    sortable: true,
    grow: 1,
  },
  {
    name: 'Order #',
    selector: 'order_no',
    sortable: true,
    grow: 0.75,
  },
  {
    name: 'Date',
    selector: 'date',
    sortable: true,
    grow: 0.75,
    format: (row: { date?: string | null }) => formatCompletedAt(row.date),
  },
  {
    name: 'Completed At',
    selector: 'completed_at',
    sortable: true,
    grow: 0.75,
    format: (row: { completed_at?: string | null }) => formatCompletedAt(row.completed_at),
  },
];

const clearFilterSetting = {
  home_inspection_job_scheduled_date_gteq: '',
  home_inspection_job_scheduled_date_lteq: '',
  home_inspection_job_customer_name_i_cont: '',
  home_inspection_job_order_no_i_cont: '',
  home_inspection_job_emp_id_i_cont: '',
};

const InspectionReportListPage: React.FC = () => {
  const { data: technicianOptions } = useGet<{ technician_options: SelectOption[] }>({
    url: '/home_services/inspection_jobs/new',
  });

  const reportFilters = [
    {
      label: 'Technician',
      type: 'select',
      param: 'home_inspection_job_emp_id_i_cont',
      choices: technicianOptions?.data?.technician_options || [],
      width: 2,
    },
    {
      label: 'Date',
      type: 'datePicker',
      param: 'home_inspection_job_scheduled_date',
      width: 5,
    },
  ];

  return (
    <Grid container>
      <Grid item xs={12}>
        <ListPage
          clickableRows
          clearedFilterSetting={clearFilterSetting}
          columns={reportColumns}
          controller="home_services/inspection_reports"
          additionalParams={{ status: 'completed' }}
          defaultSort="created_at desc"
          defaultFilters={{}}
          filterDefinitions={reportFilters}
          includeFilterBar
          queryPlaceholder="Search by Customer or Order #"
          title="Home Services"
          subtitle="Completed Reports"
          rowClickPath="home_services/reports"
        />
      </Grid>
    </Grid>
  );
};

export default InspectionReportListPage;
